import { gql } from '@apollo/client'
import { MUTATION_STATE, VOOH_MEDIA_TREE_FIELDS } from 'api/fragments'

const PAYLOAD_TYPE = 'CreateVoohCampaignPayload'

export const CREATE_VOOH_CAMPAIGN = gql`
  ${VOOH_MEDIA_TREE_FIELDS}
  ${MUTATION_STATE(PAYLOAD_TYPE)}
  mutation createVoohCampaign(
    $agencyId: ID
    $name: String!
    $briefName: String!
    $startDate: ISO8601DateTime!
    $endDate: ISO8601DateTime!
    $advertiserId: ID
    $sourceMedia: VoohCampaignSourceMediaEnum!
    $brandId: ID
    $networkId: ID
  ) {
    createVoohCampaign(
      input: {
        agencyId: $agencyId
        advertiserId: $advertiserId
        name: $name
        briefName: $briefName
        startDate: $startDate
        endDate: $endDate
        sourceMedia: $sourceMedia
        brandId: $brandId
        networkId: $networkId
      }
    ) {
      voohCampaign {
        id
        media {
          id
        }
       mediaTree {
        ...VoohMediaFields
       }
      }
      ...MutationState${PAYLOAD_TYPE}Fields
    }
  }
`
